import React from 'react';
import { Img } from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Margin, P } from '@helpers';

import { getImage } from "gatsby-plugin-image"

export const Grammar = ({getPng, t}) => {
  return (
    <PageWrapper darkMode={false}>
        <Container paddingTop='99px' marginLeft='102px' paddingBottom='32px' marginRight='69px'>
          <Text width='657px' paddingBefforeText="45px">
            <h1>{t("Grammar and checkup")}</h1>
            <p>
            {t("We strictly believe that grammar goes hand in hand with clarity, which in turn allows us to establish the necessary level of communication with potential clients. The following set of requirements will help customize content to meet these goals.")}
            </p>
          </Text>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="56px">
              <P weight='600' size='15px' height='30px'>{t("Capitalization")}</P>
              <P weight='400' size='15px' height='30px'>
                {t("All words in the names of Soft-FX products and solutions should be written with capital letters, except for articles and prepositions (i.e. auxiliary parts of speech).")} 
              </P>
              <P weight='400' size='15px' height='30px' color='#005090' marginTop='30px'>
                {t("Ex.: TickTrader Liquidity Aggregator")}
              </P>
            </Margin>
            <P weight='700' size='40px' height='48.86px' space='0.02em' color='#f2f2f2' marginTop='28px'>Aa</P>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="49px">
              <P weight='600' size='15px' height='30px'>{t("Punctuation")}</P>
              <P weight='400' size='15px' height='30px'>
                {t("Correct punctuation must be followed without question, since errors in punctuation can distort the meaning of a sentence and thus mislead the reader. This is a situation that we try to avoid by all means. Even when punctuation errors do not change the meaning of a sentence, they tend to make the text more difficult to understand.")}
              </P>
            </Margin>
            <P weight='700' size='40px' height='48.86px' space='0.02em' color='#f2f2f2' marginTop='28px'>,.-/!</P>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='50px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="73px">
              <P weight='600' size='15px' height='30px'>{t("Em Dashes (Double Hyphens or Long Dashes)")}</P>
              <P weight='400' size='15px' height='30px'>
                {t("We use this type of dashes to expand or highlight a part of a sentence that appears to be a break in thought or to introduce a clause or insert.")}
              </P>
              <P weight='400' size='15px' height='30px' color='#005090' marginTop='30px'>
                {t("Ex.: However, the global vision of what this product should be — a hyper-flexible liquidity aggregator — allowed developers to gradually turn the pre-designed functionality into reality.")}
              </P>
            </Margin>
            <P weight='700' size='40px' height='48.86px' space='0.02em' color='#f2f2f2' marginTop='28px'>—</P>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' paddingBottom='116px'>
          <FlexDiv>
            <Margin maxWidth='602px' marginRight="34px">
              <P weight='600' size='15px' height='30px'>{t("Spell Checking Services")}</P>
              <P weight='400' size='15px' height='30px'>
                {t("Proofreading tools cannot be relied upon 100% of the time, especially when dealing with certain types of content. They, however, can be a wonderful tool to catch common errors in grammar, punctuation, or speech style.")}
              </P>
              <P weight='400' size='15px' height='30px' marginTop='30px'>
                {t("Therefore, the use of Grammarly or Hemingway Editor services is mandatory when working with content.")}
              </P>
            </Margin>
            <Margin marginTop='60px'>
              <Img image={getImage(getPng('gramarly'))} alt="gramarly" width="113px"/>
              <Margin marginTop='30px'><Img image={getImage(getPng('hemingway'))} alt="hemingway" width="108px"/></Margin>
            </Margin>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};